import React, { useState, useEffect, useRef } from 'react';
import './InputTable.scss';
import InputSelect from '../inputSelect/InputSelect';
import { product_list } from '../../store/action/product';
import { useLocation, useParams } from 'react-router-dom';
import ErrorModal from '../ErrorModal/ErrorModal';
import { getProductBatchList, getProductDetails, getProductList } from '../../services/products';
import { toast } from 'react-toastify';

const InventoryAdjustmentTable = ({
	initialRows,
	columns,
	className,
	onChange,
	value,
	disabled,
	newRowgenerate = '',
	returnInputvalue,
	tableError,
	errorCells,
	setErrorCells,
	setIsTableErrorShow,
}) => {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const [batchOptions, setBatchOptions] = useState([]);
	const [productOptions, setProductOptions] = useState([]);
	const [productDetails, setProductDetails] = useState([]);
	const [selectedRowData, setSelectedRowData] = useState({});
	const [rows, setRows] = useState([]);
	const [showError, setShowError] = useState(false);
	const inputRefs = useRef([]);
	const param = useParams();
	const paramId = param.id;
	const [loading, setLoading] = useState(false);
	const paramProductID = queryParams.get('prodid');
	const paramProductName = queryParams.get('prod');

	useEffect(() => {
		let param = `page=1&pageSize=2000`;
		fetchProduct(param);
	}, []);

	useEffect(() => {
		if (errorCells.length > 0) {
			setIsTableErrorShow(true);
		} else {
			setIsTableErrorShow(false);
		}
	}, [errorCells]);

	useEffect(() => {
		if (tableError || (tableError && rows?.length > 0 && errorCells.length > 0)) {
			const secondLastRowIndex = rows.length - 1;
			const secondLastRow = rows[secondLastRowIndex];
			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];
					return (
						(value === null || value === '') &&
						['product_id', 'batch_id', 'quantity_adjusted'].includes(col.name)
					);
				})
				.map((col) => ({
					index: secondLastRowIndex,
					name: col.name,
				}));
			setErrorCells((prevErrorCells) => [
				...prevErrorCells.filter((error) => !(error.index === secondLastRowIndex)),
				...errors,
			]);
		}
	}, [tableError]);

	useEffect(() => {
		if (paramId && !paramProductID) {
			setLoading(true);
			if (value?.length > 0) {
				setRows(value);
				setLoading(false);
			}
		} else {
			if (!paramProductID) {
				setLoading(true);
				setRows(initialRows);
				setLoading(false);
			}
		}
	}, [paramId, paramId ? value : '']);

	useEffect(() => {
		if (paramProductID) {
			fetchProduct();
			getProductBatchByProductId(paramProductID, 0);
			let initValue = [
				{
					product_id: Number(paramProductID),
					batch_id: '',
					quantity_adjusted: '',
					product_name: paramProductName,
					qty: '',
					qtyHand: '',
				},
			];
			setRows(initValue);
		}
	}, [paramProductID]);

	const getProductBatchByProductId = async (productID, index) => {
		try {
			const product_details = await getProductDetails(productID);
			let filteredProduct = product_details;
			let batch = product_details.product_batch?.map((ele) => ({
				key: ele.product_batch_id,
				value: ele.batch_no,
			}));
			setBatchOptions(batch || []);
			setSelectedRowData((prevData) => ({
				...prevData,
				[index]: filteredProduct,
			}));
		} catch (error) { }
	};

	async function handleFetchBatchNumber(productId) {
		try {
			if (productId !== undefined && productId !== '' && productId !== null) {
				const data = await getProductBatchList({ product_id: productId });
				const productBatches =
					data?.length > 0
						? data?.map((batch) => {
							return {
								key: batch?.product_batch_id,
								value: batch?.batch_no,
							};
						})
						: [];
				setBatchOptions(productBatches);
			}
		} catch (error) {
			setBatchOptions([]);
			toast.error('Something went wrong!');
		}
	}

	const fetchProduct = (param) => {
		product_list(param).then((res) => {
			if (res?.success) {
				setProductDetails(res?.data?.productWithStockCount);
				const productOptions = res?.data?.productWithStockCount?.map((ele) => ({
					key: ele?.product_id,
					value: ele?.product_name,
				}));
				setProductOptions(productOptions);
			} else {
			}
		});
	};

	const getProductByInputValue = (func, delay) => {
		let timeoutId;
		return function (...args) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	};

	// const debouncedFetchProduct = getProductByInputValue((query) => {
	// 	fetchProduct(query);
	// }, 300);

	const getProductById = (productId) => {
		return productDetails?.find((product) => product.product_id === productId);
	};

	const addRow = () => {
		const emptyRow = columns.reduce((acc, col) => {
			acc[col.name] = '';
			return acc;
		}, {});
		const newRows = [...rows, emptyRow];
		setRows(newRows);

		if (newRows.length > 1) {
			const secondLastRowIndex = newRows.length - 2;
			const secondLastRow = newRows[secondLastRowIndex];

			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];
					return (
						(value === null || value === '') &&
						['product_id', 'batch_id', 'quantity_adjusted'].includes(col.name)
					);
				})
				.map((col) => ({
					index: secondLastRowIndex,
					name: col.name,
				}));

			setErrorCells((prevErrorCells) => [
				...prevErrorCells.filter((error) => !(error.index === secondLastRowIndex)),
				...errors,
			]);
		}

		if (onChange) {
			onChange(newRows);
		}
		setTimeout(() => {
			inputRefs.current[newRows.length - 1]?.[0]?.focus();
			let lastRowRef = inputRefs.current[newRows.length - 1]?.[0];
			lastRowRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}, 0);
	};

	const deleteRow = (index) => {
		if (rows.length > 1) {
			const newRows = [...rows];
			newRows.splice(index, 1);
			const newErrorCells = errorCells
				.filter((error) => error.index !== index)
				.map((error) => ({
					...error,
					index: error.index > index ? error.index - 1 : error.index,
				}));
			setErrorCells(newErrorCells);
			setRows(newRows);
			if (onChange) {
				onChange(newRows);
			}
			setTimeout(() => {
				inputRefs.current[newRows.length - 1]?.[0]?.focus();
			}, 0);
		} else {
			setRows(initialRows);
		}
	};

	const handleChange = (index, event) => {
		let { name, value } = event.target;
		value = value?.replace(/[^0-9.]/g, '');
		const decimalCount = (value.match(/\./g) || []).length;
		let stockInhand = 0;
		if (decimalCount > 1) {
			value = +value?.slice(0, value.lastIndexOf('.'));
		}

		stockInhand = rows[index]?.qty - value;

		if (rows[index]?.qty && +value <= rows[index]?.qty) {
			setErrorCells(errorCells.filter((cell) => !(cell.index === index && cell.name === name)));
		} else {
			setErrorCells([...errorCells, { index, name }]);
		}
		const newRows = [...rows];
		newRows[index].qtyHand = stockInhand === 0 ? '' : stockInhand;
		newRows[index][name] = value;
		setRows(newRows);
		if (onChange) {
			onChange(newRows);
		}
	};

	const handleProductInputChange = async (index, value) => {
		setBatchOptions([]);
		// if (rows.length === 1 && value && isNaN(rows?.product_id)) {
		// 	getProductBatchByProductId(value, index);
		// }
		const newRows = [...rows];
		if (!isNaN(value)) {
			// let param = `filterBy=product_id&filterValue=${value}`;
			// debouncedFetchProduct(param);
			const filteredProduct = getProductById(value);
			setSelectedRowData((prevData) => ({
				...prevData,
				[index]: filteredProduct,
			}));
		}
		const selectedProduct = productOptions?.find((prod) => prod?.key === value);
		newRows[index].product_id = selectedProduct?.key || '';
		var data;
		if (!isNaN(value) && value !== '') {
			data = await getProductList({
				filterBy: 'product_id',
				filterValue: value,
			});
		} else {
			data = null;
		}

		if (data != null && data?.productWithStockCount?.length > 0) {
			const batch = data?.productWithStockCount[0]?.product_batch?.map((ele) => ({
				key: ele.product_batch_id,
				value: ele.batch_no,
			}));
			setBatchOptions(batch);
		} else {
			setBatchOptions([]);
		}

		if (value === '') {
			setErrorCells([...errorCells, { index, name: 'product_id' }]);
		} else {
			setErrorCells(
				errorCells.filter((cell) => !(cell.index === index && cell.name === 'product_id')),
			);
		}

		newRows[index].product_id = value;
		newRows[index].batch_id = '';
		newRows[index].quantity_adjusted = '';
		newRows[index].qty = '';
		newRows[index].qtyHand = '';

		setRows(newRows);
		if (onChange) {
			onChange(newRows);
		}
	};

	const handleBatchChange = (index, value, indexName) => {
		let name = indexName;
		let ProductCode = isNaN(rows[index]?.product_name)
			? rows[index]?.product_id
			: rows[index]?.product_name;
		let batchCode = isNaN(rows[index]?.batch_no) ? rows[index]?.batch_id : rows[index]?.batch_no;
		if (paramId) {
			setBatchOptions([]);
			getProductBatchByProductId(ProductCode, index);
		}

		if (value) {
			let updatedErrorCell = errorCells.filter(
				(cell) => !(cell.index === index && cell.name === 'batch_id'),
			);
			setErrorCells(updatedErrorCell);
			const filteredBatch = selectedRowData[index]?.product_batch?.find(
				(ele) => (ele.product_batch_id || ele.batch_no) === value,
			);

			let filterProductselectedIndex = productDetails.filter((ele) => {
				return ele?.product_id === ProductCode;
			});

			let batch_qty = filterProductselectedIndex?.[0]?.product_batch?.filter((item) => {
				return item?.product_batch_id === batchCode;
			});

			const availableQuantity =
				filteredBatch?.free_quantity + filteredBatch?.quantity || batch_qty?.[0]?.quantity || 0;

			const newRows = [...rows];
			newRows[index][name] = isNaN(value) ? batchCode : value;
			// newRows[index].batch_no = batch_qty?.batch_no;
			newRows[index].qty = availableQuantity;
			newRows[index].qtyHand = '';
			newRows[index].quantity_adjusted = '';
			setRows(newRows);
			if (onChange) {
				onChange(newRows);
			}
		} else {
			setErrorCells([...errorCells, { index, name: 'batch_id' }]);
		}
	};

	const handleKeyDown = (index, event) => {
		let { name, value } = event.target;
		if (event.key === 'Enter') {
			const column = columns.find((col) => col.name === event.target.name);
			if (
				(column && column.label === newRowgenerate) ||
				(column && column.label === 'Quantity In Hand')
			) {
				addRow();
			}
		} else {
			if (name === 'quantity_adjusted') {
				handleChange(index, event);
			}
		}
	};

	const handleRef = (rowIndex, cellIndex) => (el) => {
		if (!inputRefs.current[rowIndex]) {
			inputRefs.current[rowIndex] = [];
		}
		inputRefs.current[rowIndex][cellIndex] = el;
	};

	const getToolTipData = (name) => {
		switch (name) {
			case 'product_id':
				return 'Name can not be empty.';
			case 'batch_id':
				return 'Batch No can not be empty';
			case 'quantity_adjusted':
				return `Quantity Adjusted can not be greater than Quantity Available`;
			default:
				return '';
		}
	};

	useEffect(() => {
		if (rows.length > 0 && onChange) {
			onChange(rows);
		}
	}, [disabled]);

	const ErrorModalOpen = () => {
		setShowError(true);
	};
	const CloseErrorModal = () => {
		setShowError(false);
		setTimeout(() => {
			if (rows.length > 0) {
				inputRefs.current[rows.length - 1]?.[0]?.focus();
			}
		}, 0);
	};

	return (
		<>
			{errorCells && errorCells?.length > 0 && (
				<div className="d-flex justify-content-end  text-danger  mb-0">
					{' '}
					<span
						style={{ textDecoration: 'underline', cursor: 'pointer' }}
						onClick={ErrorModalOpen}
					>
						Show all error
					</span>
				</div>
			)}
			<div className="text-center mb-2 custum_table">
				<div className="custom-scroll">
					<table className="purchase-table">
						<thead>
							<tr>
								{columns.map((col) => (
									<th
										className={`${className}`}
										key={col.name}
									>
										<div
											style={{
												display: 'flex',
												justifyItems: 'start',
												alignItems: 'center',
											}}
										>
											<span>{col.label}</span>
											<span style={{ color: 'red' }}>
												{['product_id', 'batch_id', 'qty', 'quantity_adjusted', 'qtyHand'].includes(
													col.name,
												)
													? '*'
													: ''}
											</span>
											{['product_id', 'batch_id', 'quantity_adjusted'].includes(col.name) ? (
												<i className="toolTip_custum fa fa-info-circle">
													<span className="toolTip_custumtext">{getToolTipData(col.name)}</span>
												</i>
											) : (
												''
											)}
										</div>
									</th>
								))}
								<th>Actions</th>
							</tr>
						</thead>
						{loading ? (
							<div
								className="d-flex justify-content-center align-items-center"
								style={{
									marginTop: '5%',
									marginLeft: '40%',
									position: 'fixed ',
								}}
							>
								<span
									className="Page_loader"
									role="status"
									aria-hidden="true"
								></span>
							</div>
						) : (
							<tbody>
								{rows.map((row, rowIndex) => (
									<tr key={rowIndex}>
										{columns.map((col, cellIndex) => (
											<td
												key={col.name}
												className={
													errorCells.some(
														(cell) => cell.index === rowIndex && cell.name === col.name,
													)
														? 'error'
														: ''
												}
											>
												{col.type === 'batch_no' ? (
													<InputSelect
														placeholder="Select Batch No"
														value={
															batchOptions?.find((option) => option.key === row[col.name])?.value ||
															row[col.name]
														}
														onChange={(value) => {
															if (value === '') {
																handleBatchChange(rowIndex, value, col?.name);
															}
														}}
														onSelect={(option) =>
															handleBatchChange(rowIndex, option.key, col?.name)
														}
														// propKeydown={(e) =>
														// 	handleBatchChange(rowIndex, e.target.value, col?.name)
														// }
														options={batchOptions}
														returnInputValue={false}
														disabled={disabled}
														propInputRef={handleRef(rowIndex, cellIndex)}
														isLocalValidationError={
															errorCells.some(
																(cell) => cell.index === rowIndex && cell.name === col.name,
															)
																? true
																: false
														}
														onClickDropdownIcon={() => {
															if (row?.product_id !== undefined && row?.product_id !== null) {
																handleFetchBatchNumber(row?.product_id);
															}
														}}
														onfucusCapture={(e) => {
															if (row?.product_id !== undefined && row?.product_id !== null) {
																handleFetchBatchNumber(row?.product_id);
															}
														}}
													/>
												) : col.type === 'product_name' ? (
													<InputSelect
														placeholder="Select Product"
														value={
															productOptions?.find((option) => option.key === row[col.name])
																?.value || row[col.name]
														}
														onChange={(value) => {
															handleProductInputChange(rowIndex, value);
														}}
														onSelect={(option) => {
															if (option?.key !== row[col.name]) {
																handleProductInputChange(rowIndex, option.key);
															}
														}}
														isLocalValidationError={
															errorCells.some(
																(cell) => cell.index === rowIndex && cell.name === col.name,
															)
																? true
																: false
														}
														options={productOptions}
														disabled={disabled}
														returnInputValue={true}
														propInputRef={handleRef(rowIndex, cellIndex)}
													/>
												) : (
													<input
														className="table_input"
														type={col.type}
														name={col.name}
														value={row[col.name]}
														style={{
															border: '1px solid rgba(85, 91, 103, 0.15)',
															borderRadius: '8px',
															height: '38px',
														}}
														onChange={(e) => handleChange(rowIndex, e)}
														onKeyDown={(e) => handleKeyDown(rowIndex, e)}
														disabled={
															disabled
																? disabled
																: col.name === 'qtyHand' || col.name === 'qty'
																	? true
																	: false
														}
														ref={handleRef(rowIndex, cellIndex)}
													/>
												)}
											</td>
										))}
										<td>
											{!(row?.adjustment_details_id || disabled) && (
												<button
													className="delete mt-0 bg-transparent"
													onClick={() => deleteRow(rowIndex)}
													tabIndex="-1"
													disabled={disabled}
												>
													<svg
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
													>
														<path
															d="M3 6H5H21"
															stroke="#FF0000"
															strokeWidth="2"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
														<path
															d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
															stroke="#FF0000"
															strokeWidth="2"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
														<path
															d="M10 11V17"
															stroke="#FF0000"
															strokeWidth="2"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
														<path
															d="M14 11V17"
															stroke="#FF0000"
															strokeWidth="2"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
													</svg>
												</button>
											)}
										</td>
									</tr>
								))}
							</tbody>
						)}
					</table>
				</div>
				{!disabled && (
					<button
						className="bg-transparent text-dark add-new-row-button mt-2"
						onClick={addRow}
					>
						Add New Row
						<i
							className="fa fa-plus"
							style={{
								marginLeft: '.5rem',
								strokeWidth: '.1rem',
								color: 'var(--brand-color)',
								WebkitTextStrokeColor: '#fff',
								WebkitTextStrokeWidth: '1px',
							}}
						/>
					</button>
				)}
			</div>
			<div className="text-start">
				{showError && (
					<ErrorModal
						show={showError}
						isOpen={showError}
						onClose={CloseErrorModal}
						title="Error in Add Inventory Table"
						error={errorCells}
					/>
				)}
			</div>
		</>
	);
};

export default InventoryAdjustmentTable;
